import { MonoTypeOperatorFunction, catchError, of, throwError } from 'rxjs';

type FirebaseLikeError = {
  code?: string;
  message?: string;
  name?: string;
};

function isFirebaseLikeError(value: unknown): value is FirebaseLikeError {
  return typeof value === 'object' && value !== null;
}

function isFirebasePermissionError(error: unknown): boolean {
  const code = isFirebaseLikeError(error) ? error.code : undefined;
  return code === 'permission-denied' || code === 'unauthenticated';
}

/**
 * Converts Firestore auth/permission errors into a safe fallback value.
 *
 * This is primarily used to prevent logout from spamming the console with
 * expected `permission-denied` errors from still-active listeners.
 */
export function catchPermissionDenied<T>(fallback: T): MonoTypeOperatorFunction<T> {
  return catchError((error: unknown) => {
    if (isFirebasePermissionError(error)) {
      return of(fallback);
    }
    return throwError(() => error);
  });
}
